import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import AccordionList from "../atoms/AccordionList";

const TabsAccordionList = () => {
	const [key, setKey] = useState("preguntas");
	return (
		<Tabs
			id='controlled-tab-example'
			activeKey={key}
			onSelect={(k) => setKey(k)}
			className='mb-3 card-header'>
			{TABS.map((tab) => (
				<Tab key={tab.key} eventKey={tab.key} title={tab.title}>
					<AccordionList array={tab.array} />
				</Tab>
			))}
		</Tabs>
	);
};

export default TabsAccordionList;

const arrGeneral = [
	{
		key: "0",
		header:
			"¿Cuánto tiempo después de ocurrido el siniestro debe el Asegurado presentar el aviso por escrito a la compañía?",
		body: "A más tardar 5 días después.",
	},
	{
		key: "1",
		header:
			"¿Cuándo la siniestralidad ocurrida es menor a la estimada para el cálculo de primas, la utilidad se puede repartir a los asegurados?",
		body: "Sí, a través de dividendos.",
	},
	{
		key: "2",
		header:
			"¿Qué características debe tener una empresa para realizar operaciones de seguros?",
		body: "Constituirse como Sociedad Anónima, contar con un capital mínimo de garantía y construir reservas técnicas.",
	},
	{
		key: "3",
		header:
			"¿Qué vigencia tiene la autorización que da la Comisión Nacional de Seguros y Fianzas a un agente persona moral?",
		body: "Es indefinida, Sin embargo, los apoderados que la representan deberán de obtener su autorización como cualquier agente, teniendo que refrendar cada 3 años.",
	},
	{
		key: "4",
		header:
			"¿Cuál es el plazo que establece la ley para el pago de las primas?",
		body: "Tendrá un plazo mínimo de 3 días después de haber sido aceptado hasta un plazo máximo de 30 días.",
	},
	{
		key: "5",
		header:
			"¿Cuáles son lo aspectos que debe informar el Agente al Contratante?",
		body: "Debe ser: Aleatorio, posible, fortuito, concreto y con contenidos económico",
	},
	{
		key: "6",
		header:
			"¿Cuáles son lo aspectos que debe informar el Agente al Contratante?",
		body: "Es obligación del agente informarle al cliente acerca del alcance de la cobertura, exclusiones, costos, manera de conservar activo el seguro, la forma de cancelar el seguro y las causas por las cuales se cancelarán las pólizas.",
	},
	{
		key: "7",
		header:
			"¿Cuántos años de prisión se impondrán a las personas que auxilien en una operación con recursos de procedencia ilícita?",
		body: "La sanción es de 5 a 15 años de prisión.",
	},
];

const arrAuto = [
	{
		key: "0",
		header: "¿Qué es un seguro para auto?",
		body: "Es un documento que protege tu vehículo contra los principales riesgos que puedan dañar tu auto asegurando también a sus ocupantes y a los bienes de otras personas.",
	},
	{
		key: "1",
		header: "¿Qué es cobertura Amplia?",
		body: "Ésta es la de mayor cobertura e incluye: Daños materiales, robo total, responsabilidad civil, extensión de responsabilidad civil, gastos médicos ocupantes, asistencia vial y asistencia legal.",
	},
	{
		key: "2",
		header: "¿Qué es cobertura Limitada?",
		body: "Esta cobertura incluye: robo total, responsabilidad civil, extensión de responsabilidad.",
	},
	{
		key: "3",
		header: "¿Qué es un seguro de Responsabilidad Civil?",
		body: "Son los daños que el asegurado, contratante o conductor causan a terceros en sus bienes o personas.",
	},
	{
		key: "4",
		header: "¿Qué es una adaptación?",
		body: "Es la modificación y/o adición en carrocería, estructura, partes, accesorios o rótulos instalados a petición del dueño del auto.",
	},
	{
		key: "5",
		header: "¿El Seguro cubre adaptaciones?",
		body: "Las adaptaciones, son una cobertura adicional que debe ser contratada por separado.",
	},
	{
		key: "6",
		header: "Tengo un auto antiguo, ¿Lo puedo asegurar en Bajatuseguro?",
		body: "Si, porque además te ofrecemos los mejores precios gracias a nuestros convenios con las principales   aseguradoras del país.",
	},
	{
		key: "7",
		header: "Tengo un auto blindado, ¿Lo puedo asegurar en Bajatuseguro?",
		body: "Si, porque además te ofrecemos los mejores precios gracias a nuestros convenios con las principales   aseguradoras del país.",
	},
	{
		key: "8",
		header: "¿Qué tipo de vehículos puedo asegurar?",
		body: "Automóviles, camionetas y camiones de hasta 3.5 toneladas, de uso particular o comercial, nacionales o fronterizo, legalizados, blindados o con equipo especial.",
	},
	{
		key: "9",
		header:
			"¿Al asegurar mi coche, quedan aseguradas las adaptaciones y/o el equipo que yo le instalé, por ejemplo, equipos de sonido, cabinas, casetas, etc?",
		body: "Sí, siempre y cuando se contraten las coberturas de equipo especial y/o adaptaciones y conversiones, ya que en la póliza sólo se especifican las autopartes y accesorios originales que el fabricante adaptó a tu auto.",
	},
	{
		key: "10",
		header: "¿Me cubre el seguro si choco mi auto por un cerrón?",
		body: "Cuando decides cerrártele a otro auto y chocan tu aseguradora se deslindará de la responsabilidad y tendrás que pagar tus daños y los del coche ajeno.",
	},
	{
		key: "11",
		header: "¿Cuándo no cubren los daños por obras?",
		body: "Cuando tu coche sufre un daño a causa de una obra vial, el daño que sufrió tu auto lo tendrá que cubrir la empresa que esté encargada de la obra.",
	},
	{
		key: "12",
		header: "¿Cubre el seguro un choque en un arrancón?",
		body: "No, si utilizas tu auto para competir con otros autos en concursos de carrera o arrancones, la aseguradora se deslinda de toda responsabilidad.",
	},
	{
		key: "13",
		header:
			"¿Cubre el seguro en el caso de ir manejando en estado de ebriedad?",
		body: "Algunas aseguradoras si te cubren dependiendo de sus condiciones generales.",
	},
	{
		key: "14",
		header: "¿En qué países me cubre mi seguro de auto?",
		body: "Cubre principalmente en México, pero si contrataste coberturas adicionales te puede cubrir también en Estados Unidos y Canadá por daños materiales, robo total, gastos médicos a ocupantes, equipo especial y adaptaciones y conversiones.",
	},
	{
		key: "15",
		header: "¿Qué documentos debo presentar al ajustador?",
		body: "Una vez que ha llegado el ajustador, es importante que cuentes a la mano con: tu póliza, tarjeta de circulación, licencia de conducir.",
	},
	{
		key: "16",
		header: "¿En qué casos se paga deducible?",
		body: "En caso de siniestro, cuando resultó ser culpa tuya y reclamas daños materiales propios, robo total, robo parcial, seguro de llantas, equipo especial y/o adaptaciones y conversiones.",
	},
	{
		key: "17",
		header:
			"¿Tengo que pagar deducible siempre que tenga un siniestro a pesar de que un tercero sea responsable del mismo?",
		body: "Cuando se tenga un tercero responsable, identificado por las autoridades competentes, no será necesario pagar deducible en caso del siniestro.",
	},
	{
		key: "18",
		header:
			"¿Cuánto me pagan por mi auto en caso de robo total o pérdida total?",
		body: "Se pagará el valor comercial de tu auto, descontando el deducible de la cobertura de robo total o daños materiales.Si tu auto es último modelo, se considerará el 90% del precio de lista que aparece en la guía EBC (libro azul) del auto asegurado.",
	},
	{
		key: "19",
		header: "¿Cuándo no cubren un robo?",
		body: "Si prestas tu auto y no te lo regresan, no se considera robo si no abuso de confianza y la aseguradora se deslinda de la responsabilidad.",
	},
	{
		key: "20",
		header: "¿Qué es valor comercial?",
		body: "Es el valor de venta vigente que aparece en la guía EBC (libro azul) del auto asegurado.",
	},
	{
		key: "21",
		header:
			"¿Si reparo mi auto antes de que la aseguradora evalúe el daño, me paga?",
		body: "Es requisito para que la aseguradora pague, que primero sea evaluado por un ajustador y/o un taller autorizado por la compañía, ya que de lo contrario la compañía de seguros no se hará responsable.",
	},
	{
		key: "22",
		header: "¿Puedo tener Licencia de conducir antes de los 18 años?",
		body: "Tendrás que tramitar un permiso de conducir que se considera como licencia.",
	},
	{
		key: "23",
		header: "¿En dónde puedo contratar el seguro de mi auto?",
		body: "Contratar el seguro de tu auto es muy sencillo, solo debes ingresar a la página de bajatuseguro.com o descargar nuestra app a tu celular y seleccionar el seguro que se adapte a tus necesidades, puedes contratarlo en línea o por call center.",
	},
	{
		key: "24",
		header: "¿Cómo puedo contratar el seguro de auto en Bajatuseguro?",
		body: "Durante la cotización que puede ser a través de nuestro portal, nuestro chat, nuestra app o si lo prefieres a través de nuestro call center. Siempre podrás contar con la opción para personalizar las coberturas que podrás incluir en la contratación de tu póliza.",
	},
	{
		key: "25",
		header: "¿Cómo puedo iniciar mi plan de seguro de auto personalizado?",
		body: "Ya sea a través del portal de Bajatuseguro, desde nuestro call center. una vez que eliges uno de nuestros planes podrás ajustar las coberturas, definir las sumas aseguradas y deducibles para armarlo justo a tu medida.",
	},
	{
		key: "26",
		header: "¿Qué necesito para contratar mi seguro?",
		body: "Durante el proceso de contratación se te solicitarán datos de tu auto, por lo que te aconsejamos tener a la mano la tarjeta de circulación o la factura.",
	},
	{
		key: "27",
		header: "¿El producto cambia, una vez que ya compre la póliza?",
		body: "No se puede cambiar de producto, los cambios solo los podrás realizar hasta su renovación.",
	},
	{
		key: "28",
		header:
			"¿Tengo que realizar pagos adicionales al costo que aparece en mi cotización?",
		body: "No, el costo que aparece en la cotización ya incluye todos los importes generados por el seguro.",
	},
	{
		key: "29",
		header: "¿Por qué mi primer recibo es mayor a los subsecuentes?",
		body: "En el primer recibo se cobran los derechos de póliza y gastos de emisión. En los demás recibos , únicamente se cobra el pago del seguro.",
	},
	{
		key: "30",
		header: "¿Qué hago si extravié mi póliza?",
		body: "¡No te preocupes! Puedes bajar tu póliza de auto desde nuestra app o bien comunícate a nuestro centro de atención al 01 800 439 2252 y un ejecutivo te ayudará a obtenerla de nuevo.",
	},
	{
		key: "31",
		header: "¿Existe una app móvil en la que pueda reportar siniestros?",
		body: "Sí, la app de Bajatuseguro es gratuita y funciona en Android, IOS y Windows. ésta te ayudará a administrar tus pólizas donde quiera que estés, llevarlas siempre contigo para el caso de alguna emergencia e inclusive podrás reportar siniestros para recibir todo el apoyo y seguimiento de nuestra área de servicio al cliente.",
	},
];

const arrAccidentes = [
	{
		key: "0",
		header: "¿Existe alguna red de Hospitales donde deba atenderme?",
		body: "No, tú puedes atenderte en el hospital de tu preferencia.",
	},
	{
		key: "1",
		header: "¿Puedo atenderme en Hospitales públicos?",
		body: "Si, puedes atenderte en cualquier institución de salud pública o privada.",
	},
	{
		key: "2",
		header: "¿Debo pagar algún deducible o coaseguro?",
		body: "No, no deberás realizar ningún pago adicional a tu prima anual a la aseguradora. (Únicamente preocúpate por pagar tu prima, y olvídate de deducibles y coaseguros, tu indemnización está libre de estos pagos)",
	},
	{
		key: "3",
		header: "¿Puedo adquirir el seguro si soy extranjero?",
		body: "Si, mientras radiques en México, puedes adquirir un seguro con nosotros.",
	},
	{
		key: "4",
		header: "¿Sólo cubren infarto al miocardio?",
		body: "Si, la cobertura del producto Infarto únicamente aplica en caso de infarto al miocardio.",
	},
	{
		key: "5",
		header:
			"¿Qué pasa si contrato el producto de CÁNCER ELLAS y me da Cáncer de Pulmón, me cubren?",
		body: "No, los productos ya están diseñados y únicamente pueden cubrir lo que muestra e las coberturas correspondientes, es decir si contratas Cáncer Ellas te cubren cáncer cervico-uterno o Mamario.",
	},
	{
		key: "6",
		header:
			"¿Qué sucede con mi póliza una vez que me ha dado alguno de los padecimientos?",
		body: `Los productos indemnizatorios solo cubren:
    <li>Infarto por primera vez </li>
    <li>Cáncer una vez que te lo han detectado y que este tipo de cáncer se ajuste a las condiciones generales del producto (consulta estas coberturas en nuestro apartado de condiciones generales)., Una vez que la compañía te cubra la póliza quedará automáticamente cancelada ya que el beneficio se ha entregado.</li>
    `,
	},
	{
		key: "7",
		header: "¿Qué documentos necesito para reclamar alguna indemnización?",
		body: (
			<>
				El Infarto Agudo al Miocardio deberá ser confirmado por un Médico
				cardiólogo calificado y se demostrará mediante evidencia de lesión y/o
				necrosis miocárdica, demostrada en el electrocardiograma, ecocardiograma
				bidimensional, sistema Doppler y/o pruebas de elevación en la
				concentración de enzimas cardiacas y/o biomarcadores cardiacos que
				confirmen la Primer Ocurrencia de Infarto al Miocardio del Asegurado. El
				Diagnóstico debe ser inequívoco y respaldado por:
				<li>
					Cuestionarios propios de la compañía AVISOS DE ACCIDENTE O ENFERMEDAD
					, E INFORME MÉDICO Una Hospitalización cuyo registro indique un
					infarto del miocardio dentro de un plazo de 24 horas antes de dicha
					Hospitalización.
				</li>
				<li>
					Un historial del típico dolor de pecho, indicativo de una enfermedad
					cardíaca isquémica.
				</li>
				<li>
					Cambios nuevos y relevantes en el electrocardiograma ECG, y/o aumento
					en las enzimas cardiacas y/o biomarcadores cardiacos por sobre los
					valores normales de laboratorio y que sean indicativos y compatibles
					con un evento agudo.
				</li>
				<li>
					El Diagnóstico debe estar soportado por tres o más de los siguientes
					criterios que son consistentes con un ataque cardíaco:Historia del
					dolor torácico típico
				</li>
				<li>
					Electrocardiograma (ECG), con cambios nuevos que demuestran un infarto
				</li>
				<li>Diagnóstico de elevación de enzimas cardiacas CPK-MB</li>
				<li>Diagnóstico de elevación de la Troponina (T o I)</li>
				<li>
					Una fracción de la eyección ventricular izquierda menor al 50%, medida
					tres (3) meses o más después del evento
				</li>
				<li>Elevación de biomarcadores cardiacos</li>
				<li>
					El Diagnóstico clínico para la cobertura de Cáncer
					deberá:Cuestionarios propios de la compañía de AVISOS DE ACCIDENTE O
					ENFERMEDAD , E INFORME MÉDICO
				</li>
				<li>
					Ser elaborado por el Médico oncólogo, ginecólogo o
					ginecólogo-oncólogo, basado en el historial clínico del Asegurado, los
					exámenes efectuados y confirmados con el estudio histopatológico o
					citológico.
				</li>
				<li>
					Basarse sobre el criterio aceptado de ser maligno, después de haber
					estudiado la composición histológica, estructura y comportamiento de
					lo que se sospecha pueda ser un tumor, un tejido o una muestra
				</li>
				<li>
					Respaldarse con una prueba patológica, es decir, con un documento que
					contenga los resultados positivos de las pruebas del diagnóstico para
					ser aceptadas como evidencia bajo los términos de este seguro, el cual
					deberá estar fechado y firmado por un Médico debidamente autorizado
					para ejercer la especialidad de oncología, osteopatía, patología o
					similar y dichas pruebas deberán estar sustentadas en los exámenes
					microscópicos de tejidos finos o preparaciones obtenidas del sistema
					óseo, hemático, linfático o similar.
				</li>
			</>
		),
	},
	{
		key: "8",
		header:
			"Una vez que entrego la documentación ¿en cuánto tiempo recibiré mi indemnización?",
		body: `El tiempo máximo para recibas tu indemnización es de 30 días, recuerda que el equipo médico tiene que evaluar la información que envíes, y el área de cobranzas deberá ingresar tu indemnización ambas deberán coordinarse y entregarte tu pago en no más de 30 días.`,
	},
];

const arrHogar = [
	{
		key: "0",
		header: "¿Para qué sirve un seguro de Hogar?",
		body: "Los accidentes no avisan y suelen provocar gastos que no tienes contemplados, un descuido podría provocar alguna incendio. un seguro de hogar te ayuda a proteger tu patrimonio contra eventos como: terremotos, inundaciones, incendios, Robos, Roturas de cristales, etc.",
	},
	{
		key: "1",
		header:
			"¿Tengo que ser dueño de la casa para contratar un seguro de hogar?",
		body: "No, si tu rentas la casa, puede asegurar los bienes que si son tuyos como tu sala, tus joyas, tus equipos de sonido, lap top, en fin lo que conocemos como contenidos, y tu puedes decidir que tipo de cobertura requieres, contra inundaciones, contra terremoto, contra robo.",
	},
	{
		key: "2",
		header: "¿Qué cubre la asistencia en el hogar?",
		body: "Servicio de profesionales calificados durante las 24 horas, con garantía de tres meses sobre los trabajos realizados y responsabilidad civil. Siempre que lo necesites te facilitaremos un profesional calificado para atender cualquier problema que surja (fontanería, electricidad, cerrajero,etc)Cerrajero de urgencia. Asesoramiento jurídico en caso de robo. Reposición temporal de electrodomésticos y otros en caso de siniestro.",
	},
	{
		key: "3",
		header: "¿Qué puedo proteger con un seguro de Hogar?",
		body: (
			<>
				<li>Daños al inmueble.</li>
				<li>Cristales.</li>
				<li>Responsabilidad Civil.</li>
				<li>Dinero y valores.</li>
				<li>Asistencia en el hogar.</li>
				<li>Daños a contenidos.</li>
				<li>Robo de contenidos.</li>
				<li>Equipo electrónico y/o Electrodoméstico.</li>
			</>
		),
	},
	{
		key: "4",
		header: "¿A qué se refieren con fenómenos Hidrometeorológicos?",
		body: `Se entiende como Fenómenos hidrometeorológicos las avalanchas de lodo, granizo, huracán, inundación, Helada, marejada, tsunami y nevada. Cabe mencionar que esta sección será cubierta, siempre que lo especifique la póliza, considerando que el fenómeno alcance por lo menos el 85% del promedio de los máximos de la zona de ocurrencia en los últimos diez años.`,
	},
	{
		key: "5",
		header: "¿Cómo puedo cotizar mi seguro de Hogar?",
		body: `¡Fácil! Ingresa a nuestro sitio web www.bajatuseguro.com y da click en la sección “Cotiza”. Después elige el ramo de tu interés. Ingresa los datos que se requieren y listo! También en nuestra APP puedes cotizar. Cotiza, Compara y Ahorra en menos de 1 minuto!¿DUDAS? Contáctanos las 24hrs los 365 días del año: Lada sin costo 01800-HEYBAJA, chat en línea, skype, e-mail contacto bajatuseguro.com, o a través de nuestras redes sociales.`,
	},
	{
		key: "6",
		header: "¿Qué debo tomar en cuenta para elegir las sumas aseguradas?",
		body: (
			<>
				Si estas rentando el inmueble:
				<li>
					La suma asegurada que debes elegir es la que corresponde a contenidos,
					y deberás considerar el valor de reposición de los bienes contenidos
					en el inmueble asegurado que será asignado por ti. Se entiende por
					"Valor de reposición" el valor de adquisición de un bien nuevo con
					mismas características.
				</li>
				<li>
					Si eres el dueño del inmueble y lo rentas: entonces debes asignar la
					suma asegurada del valor de reconstrucción del inmueble asegurado,
					excluyendo el valor del terreno en que se encuentre dicho inmueble.
				</li>
				<li>
					Si eres tu eres dueño y habitas el inmueble: En este caso deberas
					considerar ambas sumas aseguradas (El valor de reconstrucción del
					inmueble y el valor de reposición de los contenidos)
				</li>
			</>
		),
	},
	{
		key: "7",
		header: "¿Tengo que declarar objetos de valor?",
		body: `Si tus objetos de valor no superan el 20% del valor de tus contenidos, o bien no tienes ningún objeto que de forma unitaria supere los 25 mil pesos, no es necesario declarar ningún objeto de valor en póliza.`,
	},
	{
		key: "8",
		header:
			"¿Qué ocurre si no completo de forma correcta el cuestionario de seguro?",
		body: `La compañía podría anular el seguro por inexactitud de su declaración sobre el riesgo quedándose con la prima que usted hubiese pagado. Por otra parte, en caso de que ocurriese siniestro la compañía estaría en su derecho de aplicar la regla de equidad, es decir, que la indemnización se reduciría proporcionalmente a la diferencia existente entre la prima que pago y la que debería haber pagado de haber conocido la compañía la realidad del riesgo a asegurar.`,
	},
	{
		key: "9",
		header: "¿Qué vigencia tiene la Póliza?",
		body: `La vigencia de tu seguro es por un año, renovable automáticamente, iniciando el día que tu elijas.`,
	},
	{
		key: "10",
		header:
			"¿Por qué motivos pueden rechazar mi casa para adquirir un Seguro de Hogar?",
		body: `Por tener una accesoria en el inmueble, o el inmueble tuviera otro uso distinto a uso habitacional, por ser un inmueble cuya construcción no fuese sólida.`,
	},
	{
		key: "11",
		header:
			"¿A quién indemniza el seguro en caso de siniestro en una vivienda alquilada?",
		body: `Dependerá si el siniestro afecta al edificio o al contenido. Si los daños fueron producidos al inmueble, la compañía de seguros indemnizará al propietario de la vivienda. Pero, si el siniestro afecta al contenido la aseguradora reconocerá como beneficiario al inquilino o al titular de los bienes asegurados.`,
	},
	{
		key: "12",
		header:
			"¿Qué ocurre si en caso de siniestro la suma asegurada no es correcta?",
		body: `En caso de que haya asegurado sus bienes por un valor superior al que les corresponde (sobreseguro), la compañía le indemnizará el daño que realmente ha sufrido, es decir, no le pagarán más por tener más capital asegurado. Si hubiese asegurado sus bienes por un valor inferior al que les corresponde (infraseguro), la compañía, en caso de siniestro parcial, le podrá aplicar la regla proporcional, es decir, si sus bienes estuviesen asegurados al 75% de su valor real, la indemnización que percibirá será igualmente el 75% de la que le correspondería si los hubiese asegurado al 100%. En caso de siniestro total la compañía le indemnizará como máximo el capital que tenga asegurado en póliza.`,
	},
	{
		key: "13",
		header: "¿Cómo puedo efectuar el pago del Seguro?",
		body: `Es muy fácil, el cargo de tu Seguro se realiza a tu Tarjeta de Crédito y/o Débito Visa o Mastercard.`,
	},
];

const TABS = [
	{
		key: "preguntas",
		title: "Preguntas Generales",
		array: arrGeneral,
	},
	{
		key: "auto",
		title: "Auto",
		array: arrAuto,
	},
	{
		key: "accidentes",
		title: "Accidentes Personales/Salud",
		array: arrAccidentes,
	},
	{ key: "hogar", title: "Hogar", array: arrHogar },
];
